"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _objectWithoutProperties = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSearch = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _icon = require("./components/icon.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.string,
  color: _propTypes.string
} : {};
var defaultProps = {
  color: '#566'
};

var Icon = function Icon(_ref) {
  var className = _ref.className,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["className", "color"]);

  return (0, _core.jsx)("div", {
    className: className
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    d: "M9,0 C13.9705627,0 18,4.02943725 18,9 C18,11.124779 17.2636898,13.0775836 16.0323074,14.6171757 L19.7071068,18.2928932 C20.0976311,18.6834175 20.0976311,19.3165825 19.7071068,19.7071068 C19.3165825,20.0976311 18.6834175,20.0976311 18.2928932,19.7071068 L18.2928932,19.7071068 L14.6171757,16.0323074 C13.0775836,17.2636898 11.124779,18 9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 Z M9,2 C5.13400675,2 2,5.13400675 2,9 C2,12.8659932 5.13400675,16 9,16 C10.8904747,16 12.6059153,15.25059 13.8654514,14.0326404 L13.9428932,13.9428932 C13.9713525,13.914434 14.0011003,13.8880487 14.031949,13.8637373 C15.25059,12.6059153 16,10.8904747 16,9 C16,5.13400675 12.8659932,2 9,2 Z",
    id: "path-1"
  })), (0, _core.jsx)("g", {
    id: "s-icons-/-action-/-search",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("g", {
    id: "protection-area-/-system-icon"
  }, (0, _core.jsx)("rect", {
    x: "0",
    y: "0",
    width: "48",
    height: "48"
  })), (0, _core.jsx)("g", {
    id: "colors/color/colorNeutral/colorNeutral07",
    transform: "translate(14.000000, 14.000000)"
  }, (0, _core.jsx)("g", null, (0, _core.jsx)("mask", {
    id: "mask-2",
    fill: "white"
  }, (0, _core.jsx)("use", {
    xlinkHref: "#path-1"
  })), (0, _core.jsx)("use", {
    id: "Mask",
    fill: color,
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), (0, _core.jsx)("g", {
    id: "b-colors/b-color/b-colorNeutral/b-colorNeutral07",
    mask: "url(#mask-2)",
    fill: "#556666"
  }, (0, _core.jsx)("g", {
    transform: "translate(-14.000000, -14.000000)"
  }, (0, _core.jsx)("rect", {
    x: "0",
    y: "0",
    width: "48",
    height: "48"
  }))))))));
};

process.env.NODE_ENV !== "production" ? Icon.propTypes = propTypes : void 0;
Icon.defaultProps = defaultProps;
var IconSearch = (0, _stylitas.styled)(Icon)(_templateObject(), _icon.iconBase);
exports.IconSearch = IconSearch;
IconSearch.displayName = 'IconSearch';